import { render, staticRenderFns } from "./Funcionalidades.vue?vue&type=template&id=ea8de6b0"
import script from "./Funcionalidades.vue?vue&type=script&lang=js"
export * from "./Funcionalidades.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports